import type { IconComponentType } from '@creditflowresearch/uilib/Icon';
import IconDocument from '@creditflowresearch/uilib/Icon/IconDocument';
import IconFileCdi from '@creditflowresearch/uilib/Icon/IconFileCdi';
import IconFileDoc from '@creditflowresearch/uilib/Icon/IconFileDoc';
import IconFileJpg from '@creditflowresearch/uilib/Icon/IconFileJpg';
import IconFilePdf from '@creditflowresearch/uilib/Icon/IconFilePdf';
import IconFilePng from '@creditflowresearch/uilib/Icon/IconFilePng';
import IconFilePpt from '@creditflowresearch/uilib/Icon/IconFilePpt';
import IconFileTxt from '@creditflowresearch/uilib/Icon/IconFileTxt';
import IconFileXls from '@creditflowresearch/uilib/Icon/IconFileXls';
import IconFileZip from '@creditflowresearch/uilib/Icon/IconFileZip';
import IconVideo from '@creditflowresearch/uilib/Icon/IconVideo';

const ICON_BY_EXTENSION: Readonly<Record<string, IconComponentType>> = {
  cdi: IconFileCdi,
  doc: IconFileDoc,
  docx: IconFileDoc,
  ppt: IconFilePpt,
  pptx: IconFilePpt,
  xls: IconFileXls,
  xlsx: IconFileXls,
  txt: IconFileTxt,
  zip: IconFileZip,
  pdf: IconFilePdf,
  jpg: IconFileJpg,
  jpeg: IconFileJpg,
  png: IconFilePng,
  mp4: IconVideo,
  avi: IconVideo,
  mov: IconVideo,
  wmv: IconVideo,
  mkv: IconVideo,
  flv: IconVideo,
};

/**
 * The icon that stands for a downloadable file of this type.
 */
const mapFileExtensionToIcon = (extension: string): IconComponentType => (
  ICON_BY_EXTENSION[extension?.toLowerCase()] ?? IconDocument
);

export default mapFileExtensionToIcon;
